import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationStateComponent } from './configuration-state.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ViewUpdateResultsModule } from 'src/app/main/service/view-update-results/view-update-results.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';



@NgModule({
  declarations: [
    ConfigurationStateComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    PipesModule,
    IconsModule,

    ViewUpdateResultsModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ConfigurationStateComponent
  ],
})
export class ConfigurationStateModule { }
